var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHamburger = function SvgIconHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.559 9.5H2.25a1 1 0 0 0 0 2h19.5a1 1 0 1 0 0-2h-1.309a8.5 8.5 0 0 0-16.882 0m3.845-3.596A6.5 6.5 0 0 1 18.423 9.5H5.577a6.5 6.5 0 0 1 1.827-3.596M2.254 14.822l1.854-.742.042-.017 1.854-.742a1 1 0 0 1 .742 0l3.379 1.352 3.379-1.351a1 1 0 0 1 .742 0l3.379 1.351 1.483-.593.042-.017 1.854-.742a1 1 0 0 1 .742 1.858l-1.246.498v1.573a4 4 0 0 1-4 4h-9a4 4 0 0 1-4-4v-.773l-.504.201a1 1 0 0 1-.742-1.857m15.742 1.857.504-.202v.773a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-1.573l.875-.35 3.379 1.351a1 1 0 0 0 .742 0l3.379-1.351 3.379 1.351a1 1 0 0 0 .742 0"
  }))));
};
export default SvgIconHamburger;